import styled from 'styled-components';

export const StyledDiv = styled.div`
  width: 80%;
  margin-left: 10%;
  margin-bottom: 20px;
`;
